export const forums = [
  {
    id: 'f-redian',
    name: '热点讨论版',
    categoryName: '综合爆料门户',
    description:
      '全站流量最集中的讨论区，热点爆料的后续进展、多方说法与证据补充大多在这里汇总。',
    members: '128.6 万',
    threads: '96.4 万',
    tags: ['热点跟进', '多方言说', '证据补充'],
    url: 'https://luosai123.cn/forum/redian',
    mode: '开放注册',
  },
  {
    id: 'f-weiqan',
    name: '维权互助小组',
    categoryName: '民生消费维权',
    description:
      '以互助为核心的小组，成员常一起整理证据材料、商量谈判话术，并同步各自处理进度。',
    members: '64.2 万',
    threads: '38.7 万',
    tags: ['证据整理', '谈判话术', '进度同步'],
    url: 'https://luosai123.cn/forum/weiqan',
    mode: '开放注册',
  },
  {
    id: 'f-bikeng',
    name: '消费避坑交流',
    categoryName: '生活服务',
    description:
      '偏日常消费的避坑交流区，装修、家政、外卖与美妆体验都能找到大量真实反馈。',
    members: '52.8 万',
    threads: '41.3 万',
    tags: ['日常消费', '装修家政', '真实反馈'],
    url: 'https://luosai123.cn/forum/bikeng',
    mode: '开放注册',
  },
  {
    id: 'f-chengshi',
    name: '城市爆料圈',
    categoryName: '城市本地',
    description:
      '按城市分区的本地圈层，同城成员可以直接线下补充情况，也方便约定集体反映问题。',
    members: '88.5 万',
    threads: '73.1 万',
    tags: ['同城', '线下补充', '集体反映'],
    url: 'https://luosai123.cn/forum/chengshi',
    mode: '开放注册',
  },
  {
    id: 'f-caijing',
    name: '财经揭榜论坛',
    categoryName: '财经金融观察',
    description:
      '氛围相对理性的财经板块，设有材料预审与来源标注要求，讨论更偏数据与合同条款。',
    members: '31.7 万',
    threads: '18.9 万',
    tags: ['材料预审', '来源标注', '合同条款'],
    url: 'https://luosai123.cn/forum/caijing',
    mode: '邀请制',
  },
  {
    id: 'f-fanzha',
    name: '反诈经验分享',
    categoryName: '财经金融观察',
    description:
      '以反诈经验复盘为主，成员会整理完整话术时间线与止损步骤，供后来者对照识别。',
    members: '45.9 万',
    threads: '27.6 万',
    tags: ['话术时间线', '止损步骤', '经验复盘'],
    url: 'https://luosai123.cn/forum/fanzha',
    mode: '开放注册',
  },
  {
    id: 'f-zichang',
    name: '职场权益议事厅',
    categoryName: '教育职场',
    description:
      '聚焦欠薪、裁员补偿与试用期争议，常驻有熟悉劳动争议流程的老成员答疑。',
    members: '39.4 万',
    threads: '22.8 万',
    tags: ['欠薪', '裁员补偿', '流程答疑'],
    url: 'https://luosai123.cn/forum/zichang',
    mode: '开放注册',
  },
  {
    id: 'f-cheyou',
    name: '车友质检群',
    categoryName: '汽车出行',
    description:
      '按品牌与车型细分，聚集同类问题的车主，便于统计共性故障并向厂商反馈。',
    members: '26.3 万',
    threads: '15.4 万',
    tags: ['按车型', '共性故障', '厂商反馈'],
    url: 'https://luosai123.cn/forum/cheyou',
    mode: '开放注册',
  },
  {
    id: 'f-shuma',
    name: '数码真话社区',
    categoryName: '科技数码',
    description:
      '强调实测与数据的数码讨论区，禁止无依据的品牌攻击，要求附上购买渠道与批次。',
    members: '34.1 万',
    threads: '29.2 万',
    tags: ['实测数据', '购买渠道', '批次标注'],
    url: 'https://luosai123.cn/forum/shuma',
    mode: '开放注册',
  },
];